import * as types from '../mutation-types'

export const showMenu = ({ dispatch }, show) => {
    dispatch(types.SHOW_MENU, show);
}

export const toggleMenu = ({ dispatch }) => {
    dispatch(types.TOGGLE_MENU);
}



// WEBPACK FOOTER //
// ./src/vuex/main-menu/actions.js